export default __webpack_public_path__ + "static/media/posIpad.1ffd3de7.png";